import styled from '@emotion/styled';
import { InputLabel } from '@mui/material';

export const CustomInputContainer = styled.div`
  width: 100%;
  height: 100%;

  .Mui-disabled {
    background-color: ${({ theme }) => theme.palette?.brand?.gray[200]};
    border-radius: 10px;
    border: 1px solid ${({ theme }) =>
      theme.palette?.brand?.gray[300]} !important;

    :hover{
      border: ${({ theme }) => theme.palette?.brand?.gray[300]};
    }
  }
  
  .MuiInputBase-root {
    width: 100%;
    color: ${({ theme }) => theme.palette?.brand?.primary.base};
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};


    .Mui-focused .MuiOutlinedInput-notchedOutline {
      border: transparent;
    }
    
    fieldset {
     border: transparent;
    }

    :hover {
      border: 1px solid ${({ theme }) => theme.palette?.brand?.primary.base};
      
      fieldset {
        border: transparent;
      }
    }

    :focus-within {
      border: 1px solid ${({ theme }) => theme.palette?.brand?.primary.base};

      fieldset {
        border: transparent;
      }
    }
  }

`;

export const InputLoading = styled.div`
  width: 20px;
  height: 20px;

  span {
    width: 20px !important;
    height: 20px !important;
    color: ${({ theme }) => theme.palette?.brand?.primary.base} !important;
  }
`;

export const InputLabelContainer = styled(InputLabel)`
  color: ${({ theme }) => theme.palette?.brand?.secondary.base};
  font-weight: 600;
  font-size: 14px;
  font-family: 'Inter';
`;

export const TextFieldArea = styled.div`
  margin-top: 10px;
  position: relative;
  
  input {
    color: ${({ theme }) => theme.palette?.common?.black};
    height: 1.5rem;
    &::placeholder{
      font-weight: 500;
      font-size: 14px;
      font-family: 'Inter';
      color: #C3C1CA;
    }
  }
`;
